import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HttpGuard } from './core/http.guard';

const routes: Routes = [
  {
    path: ':idNeighbordhood/:idGuard',
    loadChildren: () => import('./modules/navigate/navigate.module').then(m => m.NavigatePageModule)
  },
  {
    path: 'nagivate',
    loadChildren: () => import('./modules/navigate/navigate.module').then(m => m.NavigatePageModule)
  },
  {
    path: 'home/:idNeighbordhood/:idGuard',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'nav-go',
    loadChildren: () => import('./modules/nav-go/nav-go.module').then(m => m.NavGoPageModule)
  },
  {
    path: 'guards-map',
    loadChildren: () => import('./modules/guards-map/guards-map.module').then(m => m.GuardsMapPageModule)
  },
  {
    path: 'nav-back',
    loadChildren: () => import('./modules/nav-back/nav-back.module').then(m => m.NavBackPageModule)
  },
  ];
@NgModule({ 
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
